var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.menuDatasReady)?_c('div',{staticClass:"set-list-box"},_vm._l((_vm.menuDatas),function(item,key){return _c('set-list-item',{key:key,attrs:{"item-data":item}})}),1):_c('div',{staticClass:"loading"},[_c('a-spin',{attrs:{"tip":"loading"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }